// src/utils/getEnvVar.ts

/**
 * Utility function to get an environment variable with a default fallback.
 * @param key - The environment variable key to retrieve.
 * @param defaultValue - The default value to use if the environment variable is not set.
 * @returns The value of the environment variable, or the default value if not set.
 */
const getEnvVar = (key: string, defaultValue = ""): string => {
	return process.env[key] || defaultValue;
};

export default getEnvVar;
